import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import WaterRightsList from './WaterRightsList';

//redux
import { ToastContainer } from 'react-toastify';

const WaterRights = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{ to: '#', label: 'Normativa' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Derechos de Agua' links={breadcrumbLinks} />
					<WaterRightsList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WaterRights;
